export default __webpack_public_path__ + "static/media/811.cca80e6c.png";